import React from 'react';
import './Suggestions.scss';

const Suggestions = ({ items, onClick }) => {
    return (
        <ul className="suggestions">
            {items.map((s) => (
                <li key={s.id} onClick={() => onClick && onClick(s.id)}>
                    <p className="item-name">{s.name}</p>
                    <p className="item-description">{s.description}</p>
                </li>
            ))}
        </ul>
    );
};

export default Suggestions;
